module.exports = __webpack_public_path__ + "static/media/img18.685849d5.jpg";